import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../api/quarkusApi';

const EMPTY_TOTAL = { total: 0, totalFormatted: '' };

export function useExpenseTotalByMonth(selectedDate) {
  const navigate = useNavigate();

  const [data, setData] = useState(EMPTY_TOTAL);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTotal = useCallback(() => {
    if (!selectedDate) return;
    setLoading(true);
    setError(null);
    quarkusApi
      .get('/financial/expenses/total-by-month', {
        headers: { Authorization: sessionStorage.getItem('token') },
        params: { selectedDate: selectedDate.format('YYYY/MM') },
      })
      .then((returnFromApi) => setData(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [selectedDate, navigate]);

  useEffect(() => {
    fetchTotal();
  }, [fetchTotal]);

  return { ...data, isLoading, error, refetch: fetchTotal };
}
